var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearchUnderway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "129px",
    viewBox: "0 0 129 129",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BTI_Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Research",
    transform: "translate(-799.000000, -2186.000000)",
    stroke: "#006AF9",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(801.000000, 2188.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.8448393,12.1551607 C87.0517202,28.3620416 87.0517202,54.6381798 70.8448393,70.8450607 C54.6379584,87.0516464 28.3618202,87.0516464 12.1549393,70.8450607 C-4.05164642,54.6381798 -4.05164642,28.3620416 12.1549393,12.1551607 C28.3618202,-4.05172023 54.6379584,-4.05172023 70.8448393,12.1551607 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.944927,119.46915 L119.468889,123.944921 C118.06242,125.351693 115.76039,125.351693 114.353626,123.944921 L77.0550726,86.6461428 C75.6483091,85.2393708 75.6483091,82.9376217 77.0550726,81.5308498 L81.5308165,77.055079 C82.93758,75.648307 85.2396102,75.648307 86.6460787,77.055079 L123.944927,114.353857 C125.351691,115.760629 125.351691,118.062378 123.944927,119.46915 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 71,
    x2: 79,
    y2: 79,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 20,
    x2: 28,
    y2: 63,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 32,
    x2: 42,
    y2: 64,
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 44,
    x2: 56,
    y2: 63,
    id: "Stroke-11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchUnderway);
export default __webpack_public_path__ + "static/media/Research_underway.9406b46c7c300cf23f75cf748c375d1b.svg";
export { ForwardRef as ReactComponent };